import Head from 'next/head'
import Header2 from '@/components/Header2'
import TradlyFooter from '@/partials/TradlyFooter'
import AccountPanel from '@/components/settings/AccountPanel'
import SettingsLayout from '@/layouts/SettingsLayout'
import { check_login } from 'constant/check_auth'
import { useRouter } from 'next/router'

export default function My_Account() {
  const router = useRouter()
  return (
    check_login(router, true) && (
      <SettingsLayout>
        <Head>
          <meta
            key="twitter:title"
            name="twitter:title"
            content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE.
"
          />
          <meta
            key="og:title"
            property="og:title"
            content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE.
"
          />
          <title>Tradly – Bring your Dream into Reality. API-FIRST COMMERCE.</title>
        </Head>
        <AccountPanel />
      </SettingsLayout>
    )
  )
}
